import {CellEditor} from "./CellEditor";

export class ColumnEditor {
    _cellsEditors: CellEditor[];
    constructor() {
        this._cellsEditors = [];
    }
}